import React from "react";

import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead"
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper"

import Moment from "react-moment";
// *** Redux
import { shallowEqual, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
// *** Zopa components
// *** Styling

export default function OrderContent(props) {

    const { t, i18n } = useTranslation();

    // *** 
    const loccomputedOrderlines = useSelector(state => state.registrationReducer.computedOrderlines, shallowEqual);
    const isRegistrationValidated = useSelector(state => state.registrationReducer.isRegistrationValidated, shallowEqual);


    return (
        <div style={{ overflow: 'auto' }}>
            {isRegistrationValidated &&
                <TableContainer component={Paper} style={{ marginTop: "0.5em" }}>
                    <Table aria-label="simple table" size="small" >
                        <TableHead>
                            <TableRow >
                                <TableCell align="left">{t('validation.productcolumn')}</TableCell>
                                <TableCell align="left">{t('validation.totalcolumn')}</TableCell>
                                <TableCell align="left">{t('validation.datecolumn')}</TableCell>
                                <TableCell align="left">{t('validation.endcolumn')}</TableCell>
                                <TableCell align="left">{t('validation.qtycolumn')}</TableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loccomputedOrderlines &&
                                loccomputedOrderlines.map((loccomputedOrderline, index) => (
                                    <TableRow key={index}>
                                        <TableCell align="left">
                                            <Typography > {loccomputedOrderline.label}</Typography>
                                        </TableCell>

                                        <TableCell align="left">{new Intl.NumberFormat("fr-FR", {
                                            style: "currency",
                                            currency: "EUR",
                                        }).format(loccomputedOrderline.total_ttc)
                                        }
                                        </TableCell>

                                        <TableCell align="left">
                                            {loccomputedOrderline.array_options.options_lin_datedebut && <Typography >
                                                <Moment format="DD/MM/YYYY">
                                                    {new Date(loccomputedOrderline.array_options.options_lin_datedebut * 1000)}
                                                </Moment>
                                            </Typography>
                                            }
                                        </TableCell>
                                        <TableCell align="left">
                                            {loccomputedOrderline.array_options.options_lin_datefin && <Typography >
                                                <Moment format="DD/MM/YYYY">
                                                    {new Date(loccomputedOrderline.array_options.options_lin_datefin * 1000)}
                                                </Moment>
                                            </Typography>
                                            }
                                        </TableCell>

                                        <TableCell align="left">
                                            {<Typography >
                                                {loccomputedOrderline.qty}
                                            </Typography>
                                            }
                                        </TableCell>
                                    </TableRow>
                                ))}
                            <TableRow>
                                <TableCell size="small" style={{ fontWeight: 600, backgroundColor: ' #F5F5F5' }}>{t('validation.totalcolumn')} : </TableCell>
                                <TableCell style={{ fontWeight: 600, backgroundColor: ' #F5F5F5' }}>{new Intl.NumberFormat("fr-FR", {
                                    style: "currency",
                                    currency: "EUR",
                                }).format(loccomputedOrderlines.reduce((a, b) => a + parseFloat(b.total_ttc), 0))
                                }</TableCell>

                                <TableCell align="left" style={{ fontWeight: 600, backgroundColor: ' #F5F5F5' }}></TableCell>
                                <TableCell align="left" style={{ fontWeight: 600, backgroundColor: ' #F5F5F5' }}></TableCell>
                                <TableCell align="left" style={{ fontWeight: 600, backgroundColor: ' #F5F5F5' }}></TableCell>
                            </TableRow>

                        </TableBody>
                    </Table>
                </TableContainer>}
        </div>
    );
}

